import {
	Component,
	HostListener,
	Injector,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewEncapsulation
} from '@angular/core';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {GenericListModel} from '../../../authority/authority-shared/services/dossier-general-note.service';
import {GeneralNoteModel} from '@shared/models/general-note.model';
import {Utilities} from '@shared/utilities/utilities.model';

@Component({
	selector: 'amd-general-notes',
	templateUrl: './general-notes.component.html',
	styleUrls: ['./general-notes.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class GeneralNotesComponent implements OnInit, OnChanges {

	@Input() iconClass: string;
	@Input() title: string;
	@Input() subTitle: string;
	@Input() showAction: boolean = true;
	@Input() translateContext: TranslateContext;
	@Input() ctaLabel: string;
	@Input() showCounter: boolean = true;
	@Input() showIcon: boolean = true;
	@Input() showReference: boolean = true;
	@Input() maxHeight: number = 600;
	//Mosta l'icona di cancellazione, leggere la funzione associata per maggiori informazioni sull'uso
	@Input() canLogicDelete: boolean = false;
	//Permette la gestione della lista senza api, solo a livello logico, cosi da permettere il salvataggio esternamente + nasconde la data
	@Input() logicFlow: boolean = false;
	@Input() noteConfig: Map<any, { need_sub_reference: boolean, reference_list: { id: string, description: string, type?: string }[] }>;

	translateContextEnum: typeof TranslateContext = TranslateContext;
	authorityWorkingRegex: RegExp = Utilities.patternWorkingNumberPrefix;
	items: GenericListModel;
	fetchedItems: GeneralNoteModel[] = [];
	showLoader: boolean = false;
	disableCreate: boolean = false;
	private margin: number = 100;
	protected userService: UserV3Service;

	get canCreate(): boolean {
		return this.showAction && !this.disableCreate && !!this.noteConfig && Array.from(this.noteConfig.keys()).length > 0 &&
			Array.from(this.noteConfig.values()).some(value => (value.reference_list && value.reference_list.length > 0));
	}

	constructor(protected injector: Injector) {
		this.userService = injector.get(UserV3Service);
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges): void {
	}

	isCurrentUser(user_id: string): boolean {
		return this.userService.getCurrentUser().id === user_id;
	}

	@HostListener('scroll', ['$event'])
	scrollHandler(): void {
		const container: any = document.getElementById('divToScroll');
		if (!this.showLoader && ((container.scrollHeight - container.scrollTop - container.clientHeight) <= this.margin)) {
			this.fetch();
		}
	}

	fetch(): void {
		// fetch new items
	}

	create(): void {
		// create general note
	}

	checkBodyHeigth(): void {
		if(this.logicFlow) return;
		const container: any = document.getElementById('divToScroll');
		if (!this.showLoader && (container && container.offsetHeight < this.maxHeight)) {
			this.fetch();
		}
	}

	getModuleDescription(item: GeneralNoteModel): any {
		// extra description to translate
	}


	logicDelete(index: number){
			//Elimina l'elemento da fetchedItems
			//Questa funzione viene è pensata al momento per essere usata solo per l'inserimento logico di un singolo elemento
			//E viene utilizzata per bookings Relief e Prelease in fase di inserimento reservation
	}
}
